(function () {
    'use strict';

    window.dashCsrfToken =
        document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
})();